var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalSendMail',{attrs:{"TitleWindow":'Send by E-Mail',"ModalId":_vm.modalSendMail,"Subject":_vm.conformSubject,"Cc":_vm.cc,"To":_vm.to,"Body":_vm.body},on:{"ModalClickOk":_vm.sendEmailClick}})}
var staticRenderFns = []

export { render, staticRenderFns }